import type { DynamicHelpConfig } from '../../default/cms/dynamicHelp.types';

export const dynamicHelp: DynamicHelpConfig = {
  labelMessageKey: 'forms.contact.dynamicSubject.howCanWeHelp',
  items: [
    { messageKeySelectOption: 'forms.contact.dynamicSubject.customerAccount' },
    { messageKeySelectOption: 'forms.contact.dynamicSubject.productQuestion' },
    { messageKeySelectOption: 'forms.contact.dynamicSubject.myPayments' },
    { messageKeySelectOption: 'forms.contact.dynamicSubject.shipping' },
    { messageKeySelectOption: 'forms.contact.dynamicSubject.returnsStatus' },
    { messageKeySelectOption: 'forms.contact.dynamicSubject.praemie' },
    // this will not go live until march
    // {
    //   messageKeySelectOption: 'forms.contact.dynamicSubject.reportBarrier',
    //   messageKeyAnswer: 'forms.contact.dynamicAnswer.reportBarrier',
    // },
    { messageKeySelectOption: 'forms.contact.dynamicSubject.otherQuestion' },
  ],
};
